import { useMemo } from 'react';

import { FileAttachment, LinkAttachment } from 'src/shared/components';
import { Update } from 'src/shared/types/update';

import isFileImage from '../../../utils/isFileImage';

interface ClarificationContentProps {
  update: Update;
}

const ClarificationContent: React.FC<ClarificationContentProps> = ({
  update
}) => {
  // Image attachments are shown (and deduplicated across other sources like
  // the update message and question files) by the `ImageGallery` rendered in
  // `ProductUpdateModalContent`, so only non-image files belong here to avoid
  // rendering the same images twice.
  const filesOnly = useMemo(() => {
    return update.clarification.files.filter((file) => !isFileImage(file));
  }, [update.clarification.files]);

  const renderFiles = () => {
    // fix typing when removing v1
    return filesOnly.map((file: any) => (
      <FileAttachment
        key={file.id}
        fileName={file.name}
        fileUrl={file.url}
        description={file.description}
      />
    ));
  };

  const renderLinks = () => {
    return update.clarification.links.map((file: any, index) => (
      <LinkAttachment key={index} url={file.url} caption={file.caption} />
    ));
  };

  const withAttachments = useMemo(() => {
    return filesOnly.length > 0 || update.clarification.links.length > 0;
  }, [filesOnly.length, update.clarification.links.length]);

  return (
    <div>
      {withAttachments && (
        <div className="flex gap-2 items-center mb-4">
          {filesOnly.length > 0 && renderFiles()}
          {update.clarification.links.length > 0 && renderLinks()}
        </div>
      )}
    </div>
  );
};

export default ClarificationContent;
